import React from 'react'
import WeekItem from './WeekItem';

export default function WeekList(props) {
    return (
        <div>
            {props.data.map( (item,index) =>  <WeekItem key={index} {...item} />)}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/course/E-Learning/WeekList.js